import React, {useState} from 'react'
import { TrendingUpDown } from 'lucide-react'
import { motion } from 'framer-motion'

const NormalizeSettingButton = ( {handleNormalizeSettingClick, normalizeState}) => {
    const [showLabelTooltip, settingShowLabelTooltip] = useState(false);

    const getStateColor = (state) => {
        switch (state) {
            case 'visible':
                return 'green-500'
            case 'hidden':
                return 'gray-400'
            case 'auto':
                return 'gray-600'
            default:
                return 'gray-600'
        }
    }
    
    return (
        <button
                onClick={() => handleNormalizeSettingClick(!normalizeState)}
                className={`p-2 rounded-md hover:bg-gray-300 h-[35px] w-[35px] flex items-center ${normalizeState && "bg-gray-400"}`}
                aria-label={`タグの表示状態を切り替える（現在: ${normalizeState}）`}
            >
                <motion.div
                initial={false}
                animate={{
                    scale: [1, 1.2, 1],
                    rotate: [0, 10, 0],
                }}
                transition={{ duration: 0.3 }}
                className='relative'
                onMouseEnter={() => settingShowLabelTooltip(true)}
                onMouseLeave={() => settingShowLabelTooltip(false)}
                >
                    <TrendingUpDown className={`h-5 w-5`} />
                    {showLabelTooltip && 
                        <div className={`absolute top-6 py-1 rounded-md w-[160px] border border-color-gray text-white bg-${getStateColor(normalizeState)}`}>
                            {normalizeState ? '基準化 ON' : '基準化 OFF'}
                        </div>
                    }
                    
                </motion.div>
            </button>
    )
}

export default NormalizeSettingButton